import {
	SET_BOOKINGS,
	SET_BOOKING,
	CLEAR_BOOKINGS,
	CLEAR_BOOKING,
	ADD_BOOKING,
	UPDATE_BOOKING,
	REMOVE_BOOKING,
} from './actionTypes';

export const booking = (state = {}, action) => {
	switch (action.type) {
		case SET_BOOKING:
			return action.payload;
		case UPDATE_BOOKING:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_BOOKING:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_BOOKINGS:
			return action.payload;
		case ADD_BOOKING:
			return [...state, action.payload];
		case UPDATE_BOOKING:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_BOOKING:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_BOOKINGS:
			return [];
		default:
			return state;
	}
};
